/* K-home Content-Seiten: DSGVO-Checkbox-Gate für das Kontaktformular.
   Senden-Button ist erst aktiv, wenn die Einwilligung angehakt ist. */
(function () {
  'use strict';
  function init() {
    var box = document.getElementById('KhDsgvoCheck');
    var btn = document.getElementById('KhContactSubmit');
    if (!box || !btn) return;
    var sync = function () {
      btn.disabled = !box.checked;
      btn.setAttribute('aria-disabled', String(!box.checked));
    };
    box.addEventListener('change', sync);
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
